import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <AuthShell title="Zapomenuté heslo" subtitle="Zašleme vám odkaz pro obnovení hesla">
      {sent ? (
        <div className="space-y-4">
          <p data-testid="forgot-sent" className="text-sm">Pokud e-mail existuje, poslali jsme na něj odkaz pro obnovení hesla.</p>
          <Link to="/login" className="text-brand font-semibold hover:underline text-sm">Zpět na přihlášení</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 mt-1.5" required />
          </div>
          {error && <div className="text-destructive text-sm">{error}</div>}
          <Button type="submit" data-testid="forgot-submit" className="w-full h-12 font-bold">Odeslat odkaz</Button>
          <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">Zpět na přihlášení</Link>
        </form>
      )}
    </AuthShell>
  );
}
